import { Instagram, MessageCircle } from "lucide-react";
import { business, navItems } from "../data/business";

const menu = [
    ...navItems.slice(1, 4).map((n) => n.label.toLowerCase()),
    "resultados",
    "localizacao",
];

export default function Footer() {
    return (
        <footer className="bg-ink text-paper">
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
                <div className="flex flex-col justify-between gap-12 lg:flex-row">
                    <div className="max-w-sm">
                        <p className="font-display text-xl font-semibold tracking-wide sm:text-2xl">
                            STUDIO DANIELLY SOUSA
                        </p>
                        <p className="mt-4 text-sm leading-relaxed text-paper/50">
                            {business.city} – {business.state}
                        </p>
                        <div className="mt-6 flex gap-3">
                            <a
                                href={business.instagram}
                                data-testid="footer-instagram"
                                aria-label="Instagram"
                                className="flex h-10 w-10 items-center justify-center border border-paper/20 transition-colors duration-300 hover:border-accent hover:text-accent"
                            >
                                <Instagram size={16} />
                            </a>
                            <a
                                href={business.whatsapp}
                                data-testid="footer-whatsapp"
                                aria-label="WhatsApp"
                                className="flex h-10 w-10 items-center justify-center border border-paper/20 transition-colors duration-300 hover:border-accent hover:text-accent"
                            >
                                <MessageCircle size={16} />
                            </a>
                        </div>
                    </div>

                    <nav className="grid grid-cols-2 gap-x-16 gap-y-3 sm:grid-cols-3">
                        {menu.map((m) => (
                            <a
                                key={m}
                                href={`#${m}`}
                                className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/60 transition-colors duration-300 hover:text-accent"
                            >
                                {m}
                            </a>
                        ))}
                    </nav>
                </div>

                <div className="mt-14 border-t border-line-dark pt-8">
                    <p className="max-w-2xl text-xs leading-relaxed text-paper/40">
                        Este é um projeto demonstrativo desenvolvido pela TRAX. Em
                        projetos reais, conteúdo, identidade visual, imagens e
                        estratégia são personalizados para cada empresa.
                    </p>
                    <div className="mt-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
                        <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-paper/50">
                            Desenvolvido pela TRAX
                        </p>
                        <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-paper/30">
                            Estratégia • Marketing • Vendas • Performance
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
